<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ resolvedTitle }}</h2>
        <button @click="close" :aria-label="resolvedCloseLabel">×</button>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <button @click="close">{{ resolvedCloseLabel }}</button>
        <button v-if="resolvedConfirmText" @click="confirm">{{ resolvedConfirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    confirmText: {
      type: String,
      default: null
    }
  },
  computed: {
    resolvedTitle() {
      if (this.title) {
        return this.title;
      }
      return this.$t ? this.$t('modal.defaultTitle') : 'Modal';
    },
    resolvedCloseLabel() {
      return this.$t ? this.$t('modal.close') : 'Close';
    },
    resolvedConfirmText() {
      if (this.confirmText !== null) {
        return this.confirmText || (this.$t ? this.$t('modal.confirm') : 'Confirm');
      }
      return null;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  width: 500px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.modal-header button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.modal-footer {
  margin-top: 20px;
  text-align: right;
}

.modal-footer button {
  margin-left: 10px;
}
</style>
